import * as React from "react";
function SvgTown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M0 28v-2h32v2H0zM10 8V4h12v8h6v16H4V8h6zm2 0v18h8V6h-8v2zm10 6v12h4V14h-4zM6 10v16h4V10H6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
